<template>
<div>
    <table class="table">
        <tr>
            <th>
                E-mail
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'email'" :direction="meta.direction"></sorting>

            </th>
            <th>
                Status
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'status'" :direction="meta.direction"></sorting>
            </th>
            <th>
                Zaimportowany
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'was_imported'" :direction="meta.direction"></sorting>
            </th>

        </tr>
        <tr v-for="item in items">
            <td>
                {{ item.email }}
            </td>
            <td>
                <email-status :item="item" v-if="item"></email-status>
            </td>
            <td>
                <p v-if="item.was_imported">
                    Tak. {{ item.imported_at_formated }}
                </p>
                <p v-if="!item.was_imported">
                    Nie
                </p>
            </td>

        </tr>
    </table>
    <basic-pagination :meta="meta" @pagination-page="changePage" @pagination-limit="changeLimit"></basic-pagination>
</div>
</template>

<script>
import Messages from './../../services/Messages'
import Loading from './../../mixins/Loading'
import Paginate from './../../mixins/Paginate'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Paginate, Notify],
  props: ['id'],
  methods: {
    paginate (meta) {
      this.setLoading(true)
      Messages.paginateSendTo(this.id, meta).then(this.successPaginate, this.errorPaginate)
    }
  }
}

</script>


// WEBPACK FOOTER //
// SendToList.vue?1e520452